import {
  ArticlePostPreviewActionTypes,
  useArticlePostPreviewContext,
} from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { Radio, RadioGroup } from 'components/RadioGroup'
import { useState } from 'react'
import Styles from './AlternativeOptions.module.scss'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import { Text } from 'blaze-ui/Text/Text'
import { Heading } from 'blaze-ui/Heading/Heading'
import { AlternativeOptionsMobileTopBar } from './AlternativeOptionsMobileTopBar'

export const AlternativeOptions = ({ content }: { content: string }) => {
  const { dispatch, scheduledPost } = useArticlePostPreviewContext()
  const [newContent, setNewContent] = useState(content)

  return (
    <>
      <AlternativeOptionsMobileTopBar />
      <div className={Styles.container}>
        <div className={Styles.section}>
          <Heading level={5}>Current Copy</Heading>
          <RadioGroup
            aria-label="Title"
            value={newContent}
            className={Styles.radioGroup}
            onChange={(selectedNewContent) => {
              setNewContent(selectedNewContent)
              dispatch({ type: ArticlePostPreviewActionTypes.SET_NEW_COPY, payload: selectedNewContent })
            }}
          >
            <Radio className={Styles.radioOption} value={content} hideRadio>
              {(radioBulletProps) => (
                <>
                  <div>
                    <RadioBullet {...radioBulletProps} size={20} />
                  </div>
                  <Text color="var(--dark-80)" variant="secondary">
                    <span className={Styles.content}>{content}</span>
                  </Text>
                </>
              )}
            </Radio>
          </RadioGroup>
        </div>
        <div className={Styles.section}>
          <Heading level={5}>Select from the options below</Heading>
          <RadioGroup
            aria-label="Title"
            value={newContent}
            className={Styles.radioGroup}
            onChange={(selectedNewContent) => {
              setNewContent(selectedNewContent)
              dispatch({ type: ArticlePostPreviewActionTypes.SET_NEW_COPY, payload: selectedNewContent })
            }}
          >
            {scheduledPost?.alternative_options?.map((alternativeOption, i) => {
              return (
                <Radio className={Styles.radioOption} value={alternativeOption} key={i} hideRadio>
                  {(radioBulletProps) => (
                    <>
                      <div>
                        <RadioBullet {...radioBulletProps} size={20} />
                      </div>
                      <Text color="var(--dark-80)" variant="secondary">
                        <span className={Styles.content}>{alternativeOption}</span>
                      </Text>
                    </>
                  )}
                </Radio>
              )
            })}
          </RadioGroup>
        </div>
      </div>
    </>
  )
}
